import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, propTypes as formPropTypes } from "redux-form";
import numeral from 'numeral';
import ReduxFormsField from "../common/forms/ReduxFormsField";
import cloneDeep from "lodash/cloneDeep";

const validate = (values) => {
  let errors = {};
  if (!Number.isInteger(values.days) || values.days <= 0) {
    errors.days = ['Days must be a positive number']
  }

  return errors;
};

class EditSchoolForm extends Component {
  static propTypes = {
    ...formPropTypes,
    school: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  onSubmit = (values) => {
    const submitValues = cloneDeep(values);

    return this.props.onSubmit(submitValues);
  };

  render() {
    const { handleSubmit, school, reset, onCancel, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div className="modal__content">
          <h3>Edit School</h3>
          <Field
            name="days"
            component={ReduxFormsField}
            label="Days"
            required={true}
            parse={(value) => Number(value.replace(/\D/g, ""))}
            value={school.days}
          >
            <input type="number" />
          </Field>
          <Field
            name="price"
            component={ReduxFormsField}
            label="Price"
            required={true}
            format={value => numeral(value / 100).format('$0,0.00')}
            parse={value => Number(value.replace(/\D/g, ''))}
          >
            <input type="text" />
          </Field>
          <Field
            name="location"
            component={ReduxFormsField}
            label="Location"
            required={true}
          >
            <input type="text" />
          </Field>
        </div>
        <div className="modal__actions">
          <div
            className="button button--theme--plain"
            onClick={() => {
              reset();
              onCancel();
            }}
            disabled={submitting}
          >
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "editSchoolForm",
  validate,
})(EditSchoolForm);



// WEBPACK FOOTER //
// ./src/golf-schools/EditSchoolForm.js